import { render } from "./LandscapingView.vue?vue&type=template&id=e4c56976&scoped=true"
import script from "./LandscapingView.vue?vue&type=script&lang=js"
export * from "./LandscapingView.vue?vue&type=script&lang=js"

import "./LandscapingView.vue?vue&type=style&index=0&id=e4c56976&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4c56976"]])

export default __exports__